// extracted by mini-css-extract-plugin
module.exports = {"bodyTitle":"NolBottomSheet_bodyTitle__2az6G","bodyDescription":"NolBottomSheet_bodyDescription__-yqG5","bodyContainer":"NolBottomSheet_bodyContainer__3E2Ka"};